import { Mixes } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import { useDownloadContext } from '../../DownloadOptionsModal.context'
import downloadOptionsStyles from '../DownloadOptions.module.css'
import {
	getNoMixesMessageKey,
	shouldShowMixOptionsSection,
} from '../DownloadOptions.utils'
import FieldsetSection from '../FieldsetSection'
import MixOptionsSectionContent from './MixOptionsSectionContent'

const MixOptionsSection = (): JSX.Element => {
	const { downloadOptions, initialTracks, isLoading } = useDownloadContext()
	const { t } = useTranslation('download')
	const showMixOptions = shouldShowMixOptionsSection(
		initialTracks,
		downloadOptions?.mixes,
		isLoading
	)

	return (
		<FieldsetSection
			legendIcon={<Mixes className={downloadOptionsStyles.mixOptionsIcon} />}
			title={t('mix-options')}
		>
			{showMixOptions ? (
				<MixOptionsSectionContent />
			) : (
				<span>{t(getNoMixesMessageKey(initialTracks.length))}</span>
			)}
		</FieldsetSection>
	)
}

export default MixOptionsSection
